import React, { Fragment, useMemo } from 'react'
import OrbitalInsights, { WindowKeys } from '../../../../../CommonComponents/orbital-insights/OrbitalInsights'
import { useSmartPlacement } from '../../../../../CommonComponents/modals/hooks/useSmartPlacement';
import useReportWindow from '../../../hooks/useReportWindow';
import useAssets from '../../../hooks/useAssets';
import useSelectedGroupSatellite from '../../../hooks/useSelectedGroupSatellite';
import useScenarioResponse from '../../../hooks/useScenarioResponse';
import { ModalModeType } from '../../../../../CommonComponents/modals/Modal';
import { REPORT_WINDOWS } from '../../../utils/constants';
import { SCENARIO_OPERATION_TYPES } from '../../../../constants';

const OrbitReportWindow = () => {
    const { scenarioOperationType } = useScenarioResponse()
    const { orbitalInsights, orbitStartOption } = useAssets()
    const { selectedGroupSatellite } = useSelectedGroupSatellite()
    const { windowStore, onReportModalChange } = useReportWindow()

    const modalId = 'orbital__insights__modal'
    const targetId = 'orbital__insights__report__button'

    const insightModalDetails = useMemo(() => windowStore.modals.orbitReport, [windowStore.modals.orbitReport])
    const insightTabs = useMemo(() => REPORT_WINDOWS.orbitReport.tabs, [REPORT_WINDOWS.orbitReport.tabs])

    const windowSize = useMemo(() => windowStore.modals.orbitReport.windowSize, [windowStore.modals.orbitReport.windowSize])
    const selectedTab = useMemo(() => insightModalDetails.selected as WindowKeys, [insightModalDetails.selected])

    const detachedTabs = useMemo(() => Object.entries(insightModalDetails.windows)
        .map(([name, window]) => ({ name, ...window }))
        .filter(w => w.detached).map(w => w.name), [insightModalDetails.windows])

    const selectedSatellite = useMemo(() => selectedGroupSatellite?.satelliteId, [selectedGroupSatellite?.satelliteId])
    const selectedOrbitalInsights = useMemo(() => (selectedSatellite && orbitalInsights?.data) ? orbitalInsights?.data[selectedSatellite] : null, [orbitalInsights.data, selectedSatellite])
    const { open, pinned, zIndex, position } = useMemo(() => windowStore?.modals?.orbitReport, [windowStore?.modals?.orbitReport])

    const { top, left, bottom, right } = useSmartPlacement(
        targetId,
        modalId,
        "top",
        open,
        pinned,
        {
            top: position.top,
            right: position.right,
            bottom: position.bottom,
            left: position.left
        }
    );
    const onModeClick = (e: React.MouseEvent, mode: ModalModeType) => {
        onReportModalChange(e, 'root', 'orbitReport', mode)
    }

    return (
        <Fragment>
            <OrbitalInsights
                open={open}
                pinned={pinned}
                tabs={insightTabs}
                windowSize={windowSize}
                selectedTab={selectedTab}
                detachedTabs={detachedTabs}
                showDetachedIcon={detachedTabs?.length < 2 && scenarioOperationType === SCENARIO_OPERATION_TYPES.CONOPS}
                data={selectedOrbitalInsights}
                modalId={modalId}
                className='scenario__orbital__insights__modal'
                orbitStartOption={orbitStartOption}
                scenarioOperationType={scenarioOperationType}
                style={{
                    minWidth: `${position.width}%`,
                    height: `${position.height}%`,
                    top: top,
                    right: right,
                    bottom: bottom,
                    left: left,
                    zIndex: zIndex
                }}
                onFocus={(e: React.MouseEvent) => { onReportModalChange(e, 'root', 'orbitReport', 'focus', selectedTab) }}
                onModeClick={(e: React.MouseEvent, mode: ModalModeType) => { onModeClick(e, mode) }}
                onTabSelect={(e: React.MouseEvent, tab: WindowKeys) => { onReportModalChange(e, 'child', 'orbitReport', 'select_tab', tab) }}
                onDetached={(e: React.MouseEvent, tab: WindowKeys) => { onReportModalChange(e, 'child', 'orbitReport', 'detached', tab) }}
            />
        </Fragment>
    )
}

export default OrbitReportWindow